import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import StoreSelection from './components/StoreSelection';
import ReservationForm from './components/ReservationForm';
import Footer from './components/Footer';

export default function HomePage() {
  const [selectedStoreId, setSelectedStoreId] = useState<string>('');
  const [selectedStore, setSelectedStore] = useState<string>('');
  const [selectedDate, setSelectedDate] = useState<string>('');
  const [selectedTime, setSelectedTime] = useState<string>('');
  const [showReservationForm, setShowReservationForm] = useState(false);

  const handleReservationSubmit = (storeId: string, storeName: string, date: string, time: string) => {
    setSelectedStoreId(storeId);
    setSelectedStore(storeName);
    setSelectedDate(date);
    setSelectedTime(time);
    setShowReservationForm(true);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <Navbar />
      <Hero />
      <StoreSelection onReservationSubmit={handleReservationSubmit} />
      {showReservationForm && (
        <ReservationForm
          selectedStoreId={selectedStoreId}
          selectedStore={selectedStore}
          selectedDate={selectedDate}
          selectedTime={selectedTime}
          onClose={() => setShowReservationForm(false)}
        />
      )}
      <Footer />
    </div>
  );
}
